import axios from 'axios'
import { CustomException } from '../utils/exceptions'

export const getData = async (type, val) => {
  if (type === 'connexion') {
    return getConnexions(val)
  } else {
    return getClients(val)
  }
}

export const getClients = async val => {
  let uri = '/openweb/admin/admin_liste?chpVal=code_client&chpLib=libelle_client&table=client&chpRetour=chpCodeClient&order=VAL&sortOrder=ASC&responseType=JSON'
  if (val !== '') {
    uri += '&chpRestriction=libelle_client&valRestriction='+val
  }
  const clients = await axios.get(uri)
    .catch((e) => {
      throw new CustomException(e, 'Error fetching clients')
    })
  return clients.data
}

export const getClientsResumes = async () => {
  let uri = '/service/clients'
  const clients = await axios.get(uri)
    .catch((e) => {
      throw new CustomException(e, 'Error fetching clients')
    })
  return clients.data
}

export const getTypesClient = async () => {
  let uri = '/openweb/admin/admin_liste?chpVal=code_parametrage&chpLib=libelle_parametrage&table=parametrage&order=VAL&sortOrder=ASC&responseType=JSON'
  const typesClient = await axios.get(uri)
    .catch((e) => {
      throw new CustomException(e, 'Error fetching types de client')
    })
  return typesClient.data
}

export const getConnexions = async val => {
  let uri = '/openweb/admin/admin_liste?chpVal=id_connexion&chpLib=login&table=connexion&chpRetour=chpCodeClient&order=VAL&sortOrder=ASC&responseType=JSON'
  if (val !== '') {
    uri += '&chpRestriction=code_client&valRestriction='+val
  }
  const connexions = await axios.get(uri)
    .catch((e) => {
      throw new CustomException(e, 'Error fetching clients')
    })
  return connexions.data
}
